import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useAgentProfile} from '../contexts/agent-profile-context'

export function useEventsSchemaEnabled(): boolean {
  const {interactiveSession} = useAgentProfile()
  return isFeatureEnabled('copilot_mission_control_session_events_ui') && interactiveSession
}
